import http from '../_http'

const dashboard = {
  allDashboard: (m) => { return http.post(`manager/integrity/dashboard`, m); }
}

export default dashboard

export { dashboard }